<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Tarea: {{task.title}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <router-link class="btn btn-outline-secondary" to="/tareas">{{cancelBtn.value}}</router-link>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <template v-else>
                <b-form v-on:submit.prevent="onSubmit">
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group id="taskTitle" label="Nombre:" label-for="taskTitleInput" description="">
                                <b-form-input v-model="task.title" id="taskTitleInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="taskEtapa" label="Etapa:" label-for="taskEtapaInput" description="">
                                <v-select
                                        v-model="task.stage"
                                        :options="stages"
                                        placeholder="Selecciona un valor"
                                ><span slot="no-options">Valor no encontrado</span></v-select>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="12">
                            <b-form-group id="taskContent" label="Comentario:" label-for="taskContentInput" description="">
                                <b-form-textarea v-model="task.content" id="taskContentInput" type="text"
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group id="taskFinished" label="Finalizado:" label-for="taskFinishedInput" description="">
                                <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="task.finished"
                                        name="activeInout"
                                        value="1"
                                        unchecked-value="0"
                                >
                                    Marca esta tarea como finalizada
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="taskFinishDate" label="Fecha de finalización:" label-for="taskFinishDateInput" description="">
                                <datepicker
                                        :value="task.finish_date"
                                        v-model="task.finish_date"
                                        :format="niceDate"
                                        language="es"
                                        :bootstrap-styling="true"
                                        v-on:input="closeAlert"
                                ></datepicker>
                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row>
                        <b-col md="12">

                            <b-table hover v-bind:items="task.documents" v-bind:fields="documentHeaders"
                                     outlined
                                     head-variant="light">
                                <template slot="file" slot-scope="data">
                                    <b-link v-bind:to="data.item.file.url" target="_blank">{{data.item.file.name}}</b-link>
                                </template>
                                <template slot="title" slot-scope="data">
                                    <input type="text" v-model="data.item.title">
                                </template>
                                <template slot="actions" slot-scope="data">
                                    <div class="btn-group">
                                        <b-button variant="outline-secondary" size="sm" @click="deleteDocument(data.index)">Eliminar</b-button>
                                    </div>
                                </template>
                            </b-table>

                            <b-form-group id="taskDocuments" label="Documentos:" label-for="taskDocumentsInput"
                                          description="">
                                <b-form-file
                                        id="stageDocumentsInput"
                                        v-model="documents"
                                        v-on:input="onDocumentsChange"
                                        :multiple="Boolean(true)"
                                        ref="documentsField"
                                        placeholder="Selecciona uno o mas documentos..."
                                        drop-placeholder="Arrastra hasta aquí..."
                                ></b-form-file>
                            </b-form-group>

                        </b-col>
                    </b-form-row>

                    <b-button type="submit" variant="primary" v-bind:disabled="submitBtn.disabled">{{submitBtn.value}}</b-button>
                </b-form>
                <hr>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'
    import vSelect from 'vue-select';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "TasksAdd",
        components: {
            vSelect,
            Datepicker
        },
        data() {
            return {
                isLoading: true,
                documents : [],
                documentHeaders: [
                    {key: 'file', label: 'Archivo', sortable: false},
                    {key: 'title', label: 'Título', sortable: false},
                    {key: 'actions', label: 'Acciones', sortable: false},
                ],
                cancelBtn: {
                    value: "Cancelar edición"
                },
                submitBtn: {
                    disabled: false,
                    value: "Actualizar"
                },
                deleteBtn: {
                    disabled: false,
                    value: "Eliminar esta tarea"
                }
            }
        },
        computed: {
            ...mapGetters({
                task: 'tasks/getEntries',
                stages: 'stages/getSelectableEntries',
                newDocuments: 'documents/getDocuments'
            })
        },
        methods: {
            onDocumentsChange(files) {

                return this.$store.dispatch('documents/loadDocuments', files).then(() => {
                    this.task.documents = [...this.task.documents, ...this.newDocuments];
                });

            },
            deleteDocument(index) {
                this.stage.attachment.splice(index, 1);
            },
            onSubmit() {

                this.submitBtn.disabled = true;
                this.submitBtn.value = "Actualizando...";

                this.$store.dispatch('tasks/updateEntry').then(() => {
                    this.submitBtn.value = "Tarea actualizada";
                    this.cancelBtn.value = "Regresar";
                });

            },
            deleteTask() {

                let confirm = window.confirm("¿Seguro quiere eliminar esta tarea?");

                if ( false === confirm ) {
                    return false;
                }

                this.deleteBtn.disabled = true;
                this.deleteBtn.value = "Eliminando...";

                this.$store.dispatch('tasks/deleteEntry').then(() => {
                    this.deleteBtn.value = "Tarea eliminada. Redireccionando..."
                    setTimeout(() => {
                        this.$router.push("/tareas");
                    }, 1000);
                });

            },
            niceDate(date) {
                return this.$moment(date).format('DD/MM/YYYY');
            },
            closeAlert() {
                return true;
            }
        },
        created() {
            this.$store.dispatch('tasks/setEntry', this.$route.params.id).then(() => {
                this.isLoading = false;
            });

            this.$store.dispatch('stages/loadEntries').then(() => {
                console.log('Etapas cargadas.');
            });
        }
    }
</script>

<style scoped>
    .image__grid {
        border: 1px solid #dedede;
        background-color: #f7f7f7;
        margin-bottom: 10px;
        border-radius: 3px;
    }

    .image__grid__item {
        margin: 10px;
        display: inline-block;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
        position: relative;
        max-width: 20%;
        vertical-align: text-top;
    }

    .image__grid__item img {
        max-width: 100%;
        height: auto;
    }

    .image__grid__close {
        position: absolute;
        top: 0;
        right: 0;
        background: black;
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
        cursor: pointer;
        padding: 10px;
        opacity: .5;
        transition: opacity .3s ease-in-out;
    }

    .image__grid__close:hover {
        opacity: 1;
    }
</style>